<template>
<v-container grid-list-xl fluid>
    <v-layout row wrap>
        <v-flex lg12>
            <v-card>
                <hpo-filter :headers="headers" :viewName="viewName" v-on:applyFilter="applyFilter" v-on:quickFilter="quickFilter"></hpo-filter>
                <v-data-table :headers="headers" :items="items" :options.sync="pagination" :server-items-length="total_rows" :footer-props="items_per_page" :must-sort="true"  :mobile-breakpoint="100">
                    <template v-slot:item="{ item }">
                        <tr :id="'r-' + item.ID">
                            <td>{{ item.ReportDate | display_date('DD-MM-YYYY')}}</td>
                            <td class="text-end">{{ item.FirstCumulation | currency }}</td>
                            <td class="text-end" v-if="adminRole || storeRole">
                                <v-edit-dialog :return-value.sync="item.IncomeAmount" large lazy persistent @save="saveItem({'ID': item.ID, 'IncomeAmount': item.IncomeAmount})">
                                    <div>{{ item.IncomeAmount | currency('',1)}}</div>
                                    <template v-slot:input>
                                        <h-currency-input v-model="item.IncomeAmount" :decimal="1" label="Thu" single-line autofocus></h-currency-input>
                                    </template>
                                </v-edit-dialog>
                            </td>
                            <td class="text-end" v-if="!(adminRole || storeRole)">{{ item.IncomeAmount | currency}}</td>
                            <td class="text-end" v-if="adminRole || storeRole">
                                <v-edit-dialog :return-value.sync="item.OutcomeAmount" large lazy persistent @save="saveItem({'ID': item.ID, 'OutcomeAmount': item.OutcomeAmount})">
                                    <div>{{ item.OutcomeAmount | currency('',1)}}</div>
                                    <template v-slot:input>
                                        <h-currency-input v-model="item.OutcomeAmount" type="number" :decimal="1" label="Chi" single-line autofocus></h-currency-input>
                                    </template>
                                </v-edit-dialog>
                            </td>
                            <td class="text-end" v-if="!(adminRole || storeRole)">{{ item.OutcomeAmount | currency}}</td>
                            <td class="text-end">{{ item.Cumulation | currency }}</td>
                            <td class="truncate" v-if="adminRole || storeRole">
                                <v-edit-dialog :return-value.sync="item.Reason" large lazy persistent @save="saveItem({'ID': item.ID, 'Reason': item.Reason})">
                                    <v-tooltip top right max-width="250">
                                        <template v-slot:activator="{ on }">
                                            <span v-on="on">{{ item.Reason }}</span>
                                        </template>
                                        <span>{{ item.Reason }}</span>
                                    </v-tooltip>
                                    <template v-slot:input>
                                        <v-textarea v-model="item.Reason" label="Lý do chi" single-line autofocus></v-textarea>
                                    </template>
                                </v-edit-dialog>
                            </td>
                            <!-- <td class="truncate" v-if="storeRole">{{ item.Note }}</td> -->
                            <td class="truncate" v-if="adminRole || paymentRole || storeRole">
                                <v-edit-dialog :return-value.sync="item.Note" large lazy persistent @save="saveItem({'ID': item.ID, 'Note': item.Note})">
                                    <v-tooltip top right max-width="250">
                                        <template v-slot:activator="{ on }">
                                            <span v-on="on">{{ item.Note }}</span>
                                        </template>
                                        <span>{{ item.Note }}</span>
                                    </v-tooltip>
                                    <template v-slot:input>
                                        <v-textarea v-model="item.Note" label="Ghi chú" single-line autofocus></v-textarea>
                                    </template>
                                </v-edit-dialog>
                            </td>
                            <td v-if="!(adminRole || storeRole)">{{ item.Reason }}</td>
                            <td v-if="adminRole || storeRole">
                                <v-edit-dialog :return-value.sync="item.TransactionCode" large lazy persistent @save="saveItem({'ID': item.ID, 'TransactionCode': item.TransactionCode})">
                                    <div>{{ item.TransactionCode }}</div>
                                    <template v-slot:input>
                                        <v-text-field v-model="item.TransactionCode" label="Mã vận đơn" single-line autofocus></v-text-field>
                                    </template>
                                </v-edit-dialog>
                            </td>
                            <td v-if="!(adminRole || storeRole)">{{ item.TransactionCode }}</td>
                            <td>{{ item.Customer }}</td>
                            <td>{{ item.OrderCode }}</td>
                            <td class="text-center" v-if="adminRole || paymentRole"><v-checkbox primary hide-details v-model="item.Status" @change="saveItem({'ID': item.ID, 'Status': item.Status})"></v-checkbox></td>
                            <td v-if="storeRole">{{ item.Status == 1 ? 'Đã xử lý' : 'Chưa xử lý' }}</td>
                            <td class="text-center">
                                <v-icon v-if="adminRole || storeRole" medium class="mr-2" @click="gotoDetail(item.ID)">fa-edit</v-icon>
                                <v-icon v-if="adminRole || storeRole" medium @click="deleteItem(item.ID)">fa-trash-alt</v-icon>
                            </td>
                        </tr>
                    </template>
                    <template v-slot:body.append v-if="summary">
                        <tr class="total-summary-td">
                            <td colspan="2" class="text-center font-weight-bold">Tổng</td>
                            <td class="text-end font-weight-bold">{{ summary.IncomeAmount | currency('', 2)}}</td>
                            <td class="text-end font-weight-bold">{{ summary.OutcomeAmount | currency('', 2)}}</td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                    </template>
                </v-data-table>
            </v-card>
        </v-flex>
    </v-layout>
</v-container>
</template>

<script>
import { mapState } from "vuex";
import configs from "../../configs";
import Filtering from "@/components/Filtering";
import _ from "lodash";
import { sendErrorNotice } from "@/commons/utils";

export default {
    components: {
        "hpo-filter": Filtering
    },
    data() {
        return {
            headers: [
                {
                    text: "Ngày",
                    value: "ReportDate",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Date"]
                },
                {
                    text: "Tồn đầu",
                    value: "FirstCumulation",
                    align: "end",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Thu",
                    value: "IncomeAmount",
                    align: "end",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Chi",
                    value: "OutcomeAmount",
                    align: "end",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Tồn cuối",
                    value: "Cumulation",
                    align: "end",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Lý do chi",
                    value: "Reason",
                    filterable: true,
                    quickSearch: true,
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: "Ghi chú",
                    value: "Note",
                    filterable: true,
                    quickSearch: true,
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: "Mã vận đơn",
                    value: "TransactionCode",
                    filterable: true,
                    quickSearch: true,
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: "Khách hàng",
                    value: "Customer",
                    filterable: true,
                    quickSearch: true,
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: "Mã đặt hàng",
                    value: "OrderCode",
                    filterable: true,
                    quickSearch: true,
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: "Trạng thái",
                    value: "Status",
                    filterable: true,
                    values: [
                        {value: 0, name: 'Chưa xử lý'},
                        {value: 1, name: 'Đã xử lý'},
                    ],
                    dataType: configs.DATA_TYPE["Enum"]
                },
                {
                    text: "Thao tác",
                    value: "",
                    align: "center"
                }
            ],
            pagination: { ...configs.PAGINATION, sortBy: ["ID"]},
            items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
            viewName: "storereport_list",
            filterConditions: [],
            quickFilterConditions: [],
            requireRules: [v => !!v || "Trường dữ liệu không được để trống."]
        };
    },
    watch: {
        pagination: {
            handler: function (val, oldVal) {
                let filterConditions = this.$store.state.commons.filterConditions;
                this.filterConditions = !_.isEmpty(filterConditions) ? filterConditions[this.viewName] : []
                this.filter_data();
            },
            deep: true
        },
    },
    computed: {
        ...mapState({
            items: state => state.storereport.all.data,
            total_rows: state => state.storereport.all.total,
            summary: state => state.storereport.all.summary,
            loading: state => state.storereport.loading
        }),
        tableConfig() {
            return {
                pagination: this.pagination,
                filter: this.filterConditions,
                quickFilter: this.quickFilterConditions
            };
        },
        adminRole() {
            return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Admin) == configs.ROLE_TYPE.Admin;
        },
        paymentRole() {
            return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Payment) == configs.ROLE_TYPE.Payment;
        },
        storeRole() {
            return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.StoreTQ) == configs.ROLE_TYPE.StoreTQ;
        },
    },
    methods: {
        filter_data: function () {
            this.$store.dispatch("storereport/getList", this.tableConfig);
        },
        gotoDetail: function (id) {
            this.$router.push({
                name: "StoreReportDetail",
                params: {
                    Pid: id,
                    title: `Chi tiết báo cáo thu chi (#${id})`
                }
            });
        },
        deleteItem: function(id) {
            window.getApp.$emit('REQUEST_DELETE_DATA', id);
        },
        applyFilter(filterConditions) {
            let sortBy = this.pagination.sortBy
            let sortDesc = this.pagination.sortDesc
            this.pagination = configs.PAGINATION;
            this.pagination.sortBy = sortBy;
            this.pagination.sortDesc = sortDesc;
            this.filterConditions = filterConditions;
            this.filter_data();
        },
        quickFilter(filterConditions) {
            this.quickFilterConditions = filterConditions;
            this.filter_data();
        },
        createData(username = '') {
            if(this.paymentRole) {
                sendErrorNotice("Bạn không có quyền tạo mới thu chi kho TQ.");
                return;
            }
            this.$router.push({
                name: "StoreReportDetail",
                params: {
                Pid: 'tao-moi',
                title: `Tạo mới báo cáo thu chi`
                }
            });
        },
        saveItem(obj) {
            this.$store.dispatch("storereport/setDetail", {param: this.tableConfig, data: obj, id: obj.ID});
        }
    },
    mounted() {
        this.$root.$emit('REQUEST_ROOT_OPTION', {});
        this.$root.$on("REQUEST_CREATE_DATA", this.createData);
        this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
        this.$root.$on("CONFIRMED_REMOVE_DATA", id => {
            this.$store.dispatch("storereport/removeDetail", id);
            setTimeout(this.filter_data, 200);
        });
    },
    beforeDestroy() {
        this.$root.$off("REQUEST_CREATE_DATA", this.createData);
        this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
        this.$root.$off("CONFIRMED_REMOVE_DATA");
    }
};
</script>
